import React from "react";
import { useTranslation } from "react-i18next";
import "./AllergiesStatus.css";

import TitleIcon from "@/assets/icons/Icon-allergies.png";
import SmokingIcon from "@/assets/icons/Icon-smoking.png";
import AlcoholIcon from "@/assets/icons/Icon-Alcohol.png";
import SportIcon from "@/assets/icons/Icon-Resperatory.png";

/**
 * Pure PRESENTATIONAL component
 * - No business logic
 * - No defaults
 * - No local state
 * - Displays ONLY what is passed
 */

const Pill = ({ tone = "neutral", children }) => (
  <span className={`als-pill ${tone}`}>{children}</span>
);

const Row = ({ icon, label, value }) => {
  if (!value) return null;

  return (
    <div className="als-row">
      <div className="als-left">
        <img src={icon} alt="" width={18} height={18} />
        <span>{label}</span>
      </div>
      <Pill tone={value.tone}>{value.label}</Pill>
    </div>
  );
};

export default function AllergiesStatus({ value }) {
  const { t } = useTranslation();
  
  if (!value) return null;

  return (
    <section className="als-card">
      <div className="als-head">
        <div className="als-title-icon">
          <img src={TitleIcon} alt="" width={24} height={24} />
        </div>
        <h4 className="als-title">{t('allergiesStatus.title')}</h4>
      </div>

      <div className="als-sep" />

      <Row 
        icon={SmokingIcon} 
        label={t('allergiesStatus.smoking')} 
        value={value.smoking} 
      />
      <Row 
        icon={AlcoholIcon} 
        label={t('allergiesStatus.alcohol')} 
        value={value.alcohol} 
      />
      <Row 
        icon={SportIcon} 
        label={t('allergiesStatus.physicalActivity')} 
        value={value.sport} 
      />
    </section>
  );
}